import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import useHashTable from '../../../common/hooks/useHashTable';
import useIndexedData from '../../../common/hooks/useIndexedData';
import { TreeViewContext } from '../../../context/TreeViewProvider';
import SkeletonLoader from '../decoratives/SkeletonLoader';
const DataProcessor = _ref => {
  let {
    children,
    treeNodes,
    baseLabel,
    loading,
    infLoadingIds = [],
    levels = []
  } = _ref;
  const {
    expanded = [],
    selected = [],
    setExpanded,
    setSelected
  } = useContext(TreeViewContext);
  const previousLevelClick = useCallback(e => {
    e.stopPropagation();
    setExpanded(prevExpanded => {
      const result = [...prevExpanded];
      result.pop();
      return result;
    });
  }, []);
  const getHasMore = useCallback(() => {
    if (expanded.length) {
      return infLoadingIds.includes(expanded.at(-1));
    } else {
      return levels[0] === 0;
    }
  }, [expanded, levels, infLoadingIds]);
  const {
    hashTable
  } = useHashTable(treeNodes);
  const {
    indexedItems
  } = useIndexedData(hashTable, expanded, treeNodes); // for now indexing approach
  // used a hashmap is used only for Explorer and later will be extended to TreeView
  // as well.

  const getPreviousLevel = () => {
    if (expanded.length === 1) {
      return baseLabel;
    }
    if (expanded.length > 1) {
      return hashTable.get(expanded.at(-2)).label;
    }
    return '';
  };
  return loading ? /*#__PURE__*/React.createElement(SkeletonLoader, null) : React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child, {
      ...child?.props,
      previousLevel: getPreviousLevel(),
      previousLevelClick,
      hashTable,
      records: indexedItems,
      expanded,
      selected,
      setExpanded,
      setSelected,
      hasMore: getHasMore()
    });
  });
};
DataProcessor.propTypes = {
  treeNodes: PropTypes.array,
  children: PropTypes.node,
  baseLabel: PropTypes.string,
  loading: PropTypes.bool,
  infLoadingIds: PropTypes.array,
  levels: PropTypes.array
};
export default DataProcessor;